export const PRODUCTION = true;
export const LOCAL = false;
export const DARK_MODE = true;
export const VERSION = "4.2.8";
